var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1078_4050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6313 6.14015C19.4152 5.3369 18.7818 4.7037 17.9787 4.4874C16.5114 4.08594 10.6423 4.08594 10.6423 4.08594C10.6423 4.08594 4.77348 4.08594 3.30623 4.47218C2.51854 4.68825 1.86977 5.337 1.6537 6.14015C1.26758 7.60729 1.26758 10.6499 1.26758 10.6499C1.26758 10.6499 1.26758 13.7079 1.6537 15.1597C1.86999 15.9628 2.50309 16.5961 3.30634 16.8123C4.78893 17.2139 10.6426 17.2139 10.6426 17.2139C10.6426 17.2139 16.5114 17.2139 17.9787 16.8276C18.7819 16.6115 19.4152 15.9783 19.6314 15.1751C20.0174 13.7079 20.0174 10.6654 20.0174 10.6654C20.0174 10.6654 20.0329 7.60729 19.6313 6.14015ZM8.77376 13.4608V7.83903L13.6542 10.6499L8.77376 13.4608Z",
    fill: "white",
    fillOpacity: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1078_4050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.654297 0.827148)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterYoutube);
export default __webpack_public_path__ + "static/media/footer_youtube.bf9886303cb82c642eb50824b99a697c.svg";
export { ForwardRef as ReactComponent };